export const GET_CONDITION_ITEMS = 'GET_CONDITION_ITEMS';
